import { render, staticRenderFns } from "./BrowseProducts.vue?vue&type=template&id=96146c5a&scoped=true&"
import script from "./BrowseProducts.vue?vue&type=script&lang=ts&"
export * from "./BrowseProducts.vue?vue&type=script&lang=ts&"
import style0 from "./BrowseProducts.vue?vue&type=style&index=0&id=96146c5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96146c5a",
  null
  
)

export default component.exports